import React, { useState } from 'react';
import { EditCutInfo } from './FormComponents/Form.styles';
import { SubmitButton, YellowButtonWrapper } from 'components/Button/Button.styles';
import Column from "components/Grid/Column";
import Row from "components/Grid/Row";
import TextareaField from './FormComponents/TextareaField';
import Form from './FormComponents/Form';
import CheckboxField from './FormComponents/CheckboxField';
import FeetInchesForm from "./FeetInchesForm";
import Button from 'components/Button/Button';
import LoadingOverlay from 'components/Layout/MapView/LoadingOverlay/LoadingOverlay';
import styled from 'styled-components';

import { useDavidApi } from 'utility/DavidApi/DavidApi';
import { useMsal } from "@azure/msal-react";
import { screenWidth } from 'utility/screen-width';
import prettyPhone from 'utility/prettyPhone';

// import TextField from './FormComponents/TextField';

function EditCutForm({cut, refreshCuts, formattedDate, latestStep, toggleModal, scrollTop }) {
    const api = useDavidApi();
    const { accounts } = useMsal();
    const name = accounts[0] && accounts[0].name;

    const [inputs, setInputs] = useState({
        steps: cut.steps,
        actualLength: cut.actualLength,
        actualWidth: cut.actualWidth,
        actualDepth: cut.actualDepth,
        monoCurb: cut.monoCurb,
        curb: cut.curb,
        driveway: cut.driveway,
        sidewalk: cut.sidewalk,
        flowableFill: cut.flowableFill,
        collectComments: cut.collectComments,
        comments: cut.comments
    });
    const [isChecked, setChecked] = useState(true);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const client = cut?.project?.client;
    const foreman = cut?.project?.foreman;

    const toggleChecked = (e) => {
        setChecked(!isChecked);
        const currentDate = new Date();
        currentDate.setHours(0,0,0,0);

        let steps;
        if (e.target.checked) {
            steps = [...inputs.steps, {label: e.target.name, completedAt: currentDate}];
        } else {
            steps = inputs.steps.filter((item) => {
                return item.label !== e.target.name;
            });
        }

        setInputs({...inputs, steps: steps});
    }

    const handleSubmit = (values, id) => {
        scrollTop();

        (async () => {
            setLoading(true);
            await api.patchCut(values, id);
            setTimeout(() => {
                toggleModal();
                setLoading(false);
            },
                1500
            );

            refreshCuts();
        })();
    }

    const hasValidDimensions = (length, width, depth) => {
        return [length, width, depth].some(val => typeof val === 'number' && val > 0);
    };

    const safeValue = (val) => (typeof val === 'number' ? val : 0);

    return (
        <>
            <Form
                successMessage='Cut updated!'
                id={cut.id}
                values={inputs}
                setValues={setInputs}
                errors={errors}
                setErrors={setErrors}
                asyncSubmitHandler={handleSubmit}
            >
            {loading && (
                <LoadingOverlay>
                    <h2>
                        Cut updated! Refreshing...
                    </h2>
                </LoadingOverlay>
            )}
                <Row style={{marginTop:'10px'}}>
                    <Column width={1/2}>
                        <h5>Client: </h5>
                        {client === undefined ? <EditCutInfo>No Client Provided</EditCutInfo> : <EditCutInfo>{client.name}</EditCutInfo>}
                    </Column>
                    <Column width={1/2}>
                        <h5>Foreman: </h5>
                        {foreman === undefined ? <EditCutInfo>No Foreman Assigned</EditCutInfo> : <EditCutInfo>{foreman.name} - {prettyPhone(foreman.phone)}</EditCutInfo>}
                    </Column>
                </Row>
                <Row>
                    <Column width={1/2}>
                        <h5>Order Date: </h5>
                        <EditCutInfo>{formattedDate}</EditCutInfo>
                    </Column>
                    <Column width={1/2}>
                        <h5>Work Order/SAP Number: </h5>
                        {!cut.project.workOrderNumber
                            ? <EditCutInfo>There is no project number assigned.</EditCutInfo>
                            : <EditCutInfo>{cut.project.workOrderNumber}</EditCutInfo>
                        }
                    </Column>
                </Row>
                <Row>
                    <Column width={1/2}>
                        <h5>Original Measurements:</h5>
                        {hasValidDimensions(cut.originalWidth, cut.originalLength, cut.originalDepth)
                           ? <EditCutInfo>{safeValue(cut.originalLength)} in. x {safeValue(cut.originalWidth)} in. x {safeValue(cut.originalDepth)} in.</EditCutInfo>
                           : <EditCutInfo>There are no original measurements.</EditCutInfo>
                        }
                    </Column>
                    <Column width={1/2}>
                        <h5>Address:</h5>
                        {cut.street && (
                            <EditCutInfo>{cut.address} {cut.street}</EditCutInfo>
                        )}
                        {!cut.street && (
                            <EditCutInfo>There is no address for this cut.</EditCutInfo>
                        )}
                    </Column>
                </Row>
                <Row>
                    <Column width={1/2}>
                        <h5>Actual Measurements:</h5>
                        {hasValidDimensions(cut.actualLength, cut.actualWidth, cut.actualDepth)
                            ? <EditCutInfo>{safeValue(cut.actualLength)} in. x {safeValue(cut.actualWidth)} in. x {safeValue(cut.actualDepth)} in.</EditCutInfo>
                            : <EditCutInfo>No actual measurements provided.</EditCutInfo>
                        }
                    </Column>
                </Row>
                {(latestStep === 'Digout' || latestStep === 'Base' || latestStep === 'Surface') && (
                <Row>
                    <Column width={1/1}>
                        {cut.product.surface === "Asphalt" && (
                            <>
                                <h5 style={{marginTop: '10px', marginBottom: '5px'}}>Surface Type:</h5>
                                <CheckboxField
                                    label="Driveway"
                                    name={'driveway'}
                                />

                            </>
                        )}
                        {cut.product.surface === "Concrete" && (
                            <>
                                <h5 style={{marginTop: '10px', marginBottom: '5px'}}>Surface Type:</h5>
                                <CheckboxWrapper>
                                    <CheckboxField
                                        label="Curb"
                                        name={'curb'}
                                    />
                                    <CheckboxField
                                        label="Mono Curb"
                                        name={'monoCurb'}
                                    />
                                    <CheckboxField
                                        label="Driveway"
                                        name={'driveway'}
                                    />
                                    <CheckboxField
                                        label="Sidewalk"
                                        name={'sidewalk'}
                                    />
                                </CheckboxWrapper>
                            </>
                        )}
                    </Column>
                </Row>
                )}
                {latestStep === 'Crack Fill' && (
                    <Row>
                        <Column width={1/2}>
                            <h5 style={{marginTop: '10px', marginBottom: '5px'}}>Surface Type:</h5>
                            <div style={{display: 'flex'}}>
                                {cut?.curb && <EditCutInfo>Curb</EditCutInfo>}
                                {cut?.monoCurb && <EditCutInfo>Mono Curb</EditCutInfo>}
                                {cut?.driveway && <EditCutInfo>Driveway</EditCutInfo>}
                                {cut?.sidewalk && <EditCutInfo>Sidewalk</EditCutInfo>}

                                {!cut?.curb && !cut?.monoCurb && !cut?.driveway && !cut?.sidewalk && (
                                    <EditCutInfo>
                                        There is no unique surface type specified.
                                    </EditCutInfo>
                                )}
                            </div>
                        </Column>
                        <Column width={1/2}>
                            <h5 style={{marginTop: '10px', marginBottom: '5px'}}>Items to be collected:</h5>
                            <div style={{display: 'flex'}}>
                                {(cut?.collectComments != null) ? (
                                    <EditCutInfo>{cut.collectComments}</EditCutInfo>
                                ) : (
                                    <EditCutInfo>
                                        There are no items listed for pick up.
                                    </EditCutInfo>
                                )}
                            </div>
                        </Column>

                    </Row>
                )}
                {latestStep === 'Base' && cut.product.surface !== "Special" && (
                    <>
                        <h4 style={{marginTop: '10px'}}>Update Actual Measurements</h4>
                        <hr />
                        <Row gutter={15} style={{marginBottom: '10px'}}>
                            <Column width={1/3}>
                                <CheckboxField
                                    label="Flowable Fill"
                                    name={'flowableFill'}
                                />
                            </Column>
                        </Row>
                        <Row gutter={15}>
                            <FeetInchesForm label="Length" uniqueName="actualLength" cut={cut} />
                            <FeetInchesForm label="Width" uniqueName="actualWidth" cut={cut} />
                            <FeetInchesForm label="Depth" uniqueName="actualDepth" cut={cut} />
                        </Row>
                    </>
                )}
                {latestStep === 'Surface' && cut.product.id !== 3 && (
                    <>
                        <h4 style={{marginTop: '10px'}}>Update Actual Measurements</h4>
                        <hr />
                        <Row gutter={15} style={{marginBottom: '10px'}}>
                            <Column width={1/3}>
                                <CheckboxField
                                    label="Flowable Fill"
                                    name={'flowableFill'}
                                />
                            </Column>
                        </Row>
                        <Row gutter={15}>
                            <FeetInchesForm label="Length" uniqueName="actualLength" cut={cut} />
                            <FeetInchesForm label="Width" uniqueName="actualWidth" cut={cut} />
                            <FeetInchesForm label="Depth" uniqueName="actualDepth" cut={cut} />
                        </Row>
                    </>
                )}
                <hr style={{marginBottom: '20px'}} />
                <Row>
                    <Column width={1/2}>
                        <h5>Current Step:</h5>
                        <EditCutInfo>{latestStep} - {cut.product.name}</EditCutInfo>
                    </Column>
                    {/* {latestStep === 'View' && (
                        <Column width={1/2}>
                            <CheckboxField
                                onChange={toggleChecked}
                                checked={!isChecked}
                                value={cut.steps}
                                name="View"
                                label="Approve for Digout?"
                            />
                        </Column>
                    )} */}
                    {latestStep === 'Digout' && (
                        <Column width={1/2}>
                            <CheckboxField
                                onChange={toggleChecked}
                                checked={!isChecked}
                                value={cut.steps}
                                name="Digout"
                                label="Digout Completed?"
                            />
                        </Column>
                    )}
                    {latestStep === 'Base' && (
                        <Column width={1/2}>
                            <CheckboxField
                                onChange={toggleChecked}
                                checked={!isChecked}
                                value={cut.steps}
                                name="Base"
                                label="Base Completed?"
                            />
                        </Column>
                    )}
                    {latestStep === 'Surface' && (
                        <Column width={1/2}>
                            <CheckboxField
                                onChange={toggleChecked}
                                checked={!isChecked}
                                value={cut.steps}
                                name="Surface"
                                label="Surface Completed?"
                            />
                        </Column>
                    )}
                    {latestStep === 'Concrete' && (
                        <Column width={1/2}>
                            <CheckboxField
                                onChange={toggleChecked}
                                checked={!isChecked}
                                value={cut.steps}
                                name="Concrete"
                                label="Concrete Completed?"
                            />
                        </Column>
                    )}
                    {latestStep === 'Crack Fill' && (
                        <Column width={1/2}>
                            <CheckboxField
                                onChange={toggleChecked}
                                checked={!isChecked}
                                value={cut.steps}
                                name="CrackFill"
                                label="Crack Fill Completed?"
                            />
                        </Column>
                    )}
                </Row>
                {(latestStep === 'Digout' || latestStep === 'Base' || latestStep === 'Surface') && (
                    <Row>
                        <Column width={1/1}>
                            <TextareaField
                                label="If applicable, please list any items to be picked up:"
                                name="collectComments"
                                style={{marginTop: '10px', marginBottom: '20px'}}
                            />
                        </Column>
                    </Row>
                )}
                <TextareaField
                    label="Additional Comments"
                    name="comments"
                    style={{marginBottom: '30px'}}
                />

                {/* <h4 style={{marginBottom:'25px', marginTop:'20px'}}>Completed and approved by: {name}</h4> */}

                <Row gutter={15}>
                    <Column width={3/4}>
                        <YellowButtonWrapper style={{maxWidth: '185px'}}>
                            <SubmitButton>Update</SubmitButton>
                        </YellowButtonWrapper>
                    </Column>
                    <Column width={1/4}>
                        <Button style={{maxWidth: '185px'}} to={'/projects/' + cut.project.id + '/edit'}>Edit Project</Button>
                    </Column>
                </Row>
            </Form>
        </>
    )
  }

export default EditCutForm;

const CheckboxWrapper = styled.div`
  display: flex;

  @media ${screenWidth.below.sm} {
    flex-direction: column;
  }
`;
